import { IconButton, OdinIconName, OdinIconSize } from '@myosh/odin-components';

export interface ActionIconProps {
  icon: OdinIconName;
  onClick: () => void;
  hidden?: boolean;
  iconTheme?: 'primary' | 'default';
}

const ActionIcon = ({ icon, onClick, hidden = false, iconTheme = 'primary' }: ActionIconProps) => {
  const getButtonClass = () => {
    let className = `action-icon text-primary-1 mr-2 ${iconTheme}`;
    if (hidden) {
      className += ' hidden';
    }

    return className;
  };

  return <IconButton classNames={getButtonClass()} onClick={onClick} icon={icon} iconSize={OdinIconSize.ExtraSmall} />;
};

export default ActionIcon;
